import { array, bool, object, string } from 'yup';

const SUBDOMAIN_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9.-]+[a-zA-Z0-9]$/;
const DOMAIN_REGEX =
  // eslint-disable-next-line
  /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;

const ClientSchema = () =>
  object().shape({
    title: string().required('Title is Required'),
    subdomain: string()
      .matches(SUBDOMAIN_REGEX, 'Subdomain is Invalid')
      .required('Subdomain is Required'),
    email_sending_domain: string().matches(DOMAIN_REGEX, 'Invalid Domain'),
    email_from_address: string().nullable(),
    email_domains: array().of(string()),
    content_domains: array().of(string()),
    email_address: string().email('Invalid Email'),
    allow_user_invites: bool().required(),
    allow_user_signup: bool().required(),
    allow_group_creation: bool().required(),
    departments_in_signup_required: bool().required(),
    locations_in_signup_required: bool().required(),
    support_multiple_languages: bool().required(),
    allow_external_share: bool().required(),
    sort_mode: string().nullable().oneOf([null, 'trending', 'chronological']),
    disable_timeline: bool().required(),
    disable_comments: bool().required(),
    image: object()
      .shape({
        key: string().required(),
        region: string().required(),
        bucket: string().required(),
      })
      .nullable(),
  });

export default ClientSchema;
